import { useEffect, useState } from 'react';

type BreakPointsParams =
  | 'smallMobile'
  | 'mobile'
  | 'tablet'
  | 'md'
  | 'laptop'
  | 'desktop';

const breakpoints = {
  smallMobile: 375,
  mobile: 425,
  tablet: 768,
  md: 900,
  laptop: 1024,
  desktop: 1280
};

export const useMediaQuery = (breakpoint: BreakPointsParams): boolean => {
  const [matches, setMatches] = useState(false);
  const matchQueryList = window.matchMedia(
    `screen and (max-width: ${breakpoints[breakpoint]}px)`
  );
  useEffect(() => {
    setMatches(matchQueryList.matches);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function handleChange(e) {
      setMatches(e.matches);
    }
    matchQueryList.addEventListener('change', handleChange);
    return () => {
      matchQueryList.removeEventListener('change', handleChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);
  return matches;
};
